<template>
    <v-card tile flat class="MyTrading MyBalance" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
        <v-container>
            <v-row dense>
                <v-col cols="12">
                    <v-sheet class="d-flex align-center mb-0" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
                        <div class="title">
                            <v-icon dense color="#5F7692">mdi-bag-checked</v-icon>
                            <span class="ml-2">Balance</span>
                        </div>
                        <v-spacer></v-spacer>
                        <router-link class="links" to="/wallet">See Details ></router-link>
                    </v-sheet>
                </v-col>
                <v-col cols="12">
                    <v-card-text class="d-flex pb-2 pr-0 trade align-center">
                        <p class="number mb-0">
                            {{ account_summary?.balance || 0 }} <strong>USD</strong>
                        </p>
                        <v-spacer></v-spacer>
                        <p class="equity text-right">
                            Equity: {{ account_summary?.equity || 0 }}
                            <br />Bonus:
                            {{ account_summary?.bonus || 0 }} USD
                        </p>
                    </v-card-text>
                </v-col>
                <v-col cols="12" lg="12">
                    <v-card-text class="d-flex pl-4 pt-0 pb-2 trade align-center">
                        <span class="equity">Total Profit:
                            <strong>{{
                                account_summary?.totalProfit?.toFixed(2) ||
                                0
                            }}
                                USD</strong></span>
                        <v-spacer></v-spacer>
                        <v-btn small tile elevation="0" to="/deposit" class="ma-0 text-capitalize btn-account"
                            color="greenMain">
                            Deposit
                        </v-btn>
                    </v-card-text>
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</template>

<script>
import { PROFILE__ACTIONS } from "@/store/action-types";
import { mapState, mapActions } from "vuex";

export default {
    name: "balanceCard",
    components: {},
    data() {
        return {};
    },
    computed: {
        ...mapState("account", ["account_summary"]),
    },
    methods: {
        ...mapActions("account", [PROFILE__ACTIONS.ACCOUNTSUMMARY]),
    },
    async mounted() {
        try {
            await this[PROFILE__ACTIONS.ACCOUNTSUMMARY]();
        } catch (error) {
            console.log(error);
        }
    },
};
</script>
